import { type Dispatch, type FC, type SetStateAction } from 'react'

import { Experiment } from '../../../experiments/components/Experiment'
import { ExperimentVariant } from '../../../experiments/components/ExperimentVariant'
import { EXPERIMENT_NAME_DIRECT_CONTACT_FORM_DIALOG } from '../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../experiments/model/EXPERIMENT_VARIATION'
import { type OpenableControls } from '../../../generic-hooks'
import { TENANT } from '../../../tenant'

import { DirectContactFormDialogContent } from './DirectContactFormDialogContent'
import { DirectContactFormDefault } from './DirectContactFormForms/DirectContactFormDefault'
import { DirectContactFormSuccessNotification } from './DirectContactFormSuccessNotification'

export const DirectContactFormComExperiment: FC<{
  clearSubjectOnClose: boolean
  handleSuccess?: () => void
  modalControls: OpenableControls
  onSuccessClose?: () => void
  onSuccessSubmit: boolean
  setClearSubjectOnClose: Dispatch<SetStateAction<boolean>>
  setOnSuccessSubmit: Dispatch<SetStateAction<boolean>>
}> = ({
  clearSubjectOnClose,
  handleSuccess,
  modalControls,
  onSuccessClose,
  onSuccessSubmit,
  setClearSubjectOnClose,
  setOnSuccessSubmit,
}) => {
  return (
    <Experiment names={[EXPERIMENT_NAME_DIRECT_CONTACT_FORM_DIALOG]}>
      <ExperimentVariant
        name={EXPERIMENT_VARIATION.DEFAULT}
        tenant={TENANT.COM}
      >
        <DirectContactFormDefault
          onFormSubmittedWithSuccess={() => {
            if (handleSuccess) {
              handleSuccess()
            }
          }}
        />
      </ExperimentVariant>
      <ExperimentVariant name={EXPERIMENT_VARIATION.V1}>
        {onSuccessSubmit ? (
          <DirectContactFormSuccessNotification
            handleSuccessClose={onSuccessClose}
            modalControls={modalControls}
            setOnSuccessSubmit={setOnSuccessSubmit}
          />
        ) : (
          <DirectContactFormDialogContent
            clearSubjectOnClose={clearSubjectOnClose}
            onFormSubmittedWithSuccess={() => {
              setOnSuccessSubmit(true)
            }}
            setClearSubjectOnClose={setClearSubjectOnClose}
            userModalControls={modalControls}
          />
        )}
      </ExperimentVariant>
    </Experiment>
  )
}
